import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: 'd8473d1d-a262-4ee3-b5b2-dc708fe80b3e',
  clientToken: 'pubc4cd8126dae4f711c63d3f0bf0bcf916',
  site: 'us5.datadoghq.com',

  service: 'tezlaa-frontend',
  env: 'development',
  version: '1.0.0',

  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,

  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
});

datadogRum.startSessionReplayRecording();